getExperiment = require 'lib/experiments/simple-test'
PluginButtonsView = require 'views/plugin/plugin-buttons-view'
PluginCardButtonView = require 'views/plugin/plugin-card-button-view'
simpleTest = require 'lib/experiments/simple-test'
sidebarAction = require 'views/templates/card_detail_sidebar_button'
t = require('views/internal/teacup-with-helpers')('card_detail')

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

nativeCustomFieldsEnabled = (board) ->
  board.isPluginEnabled(CUSTOM_FIELDS_ID) &&
  board.editable()

template = t.renderable ({ showCustomFields }) ->
  t.h3 'mod-no-top-margin', ->
    t.format 'plugins'
  t.div '.u-clearfix.js-button-list', ->
    if showCustomFields
      sidebarAction('js-edit-fields', 'custom-field', 'custom-fields')

module.exports = class PluginCardButtonsView extends PluginButtonsView
  tagName: 'div'
  className: 'window-module u-clearfix hide'
  buttonsSelector: '.js-button-list'
  buttonView: PluginCardButtonView

  hideContainer: (pluginButtons) ->
    pluginButtons.length == 0 && !nativeCustomFieldsEnabled(@model.getBoard())

  renderContainer: ->
    showCustomFields = nativeCustomFieldsEnabled(@model.getBoard())
    @$el.html(template({ showCustomFields }))
    @$('.js-button-list')

  runnerOptions: ->
    command: 'card-buttons'
    board: @model.getBoard()
    card: @model



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-buttons-view.coffee